import React from "react";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";
import PageHeader from "~/common/components/PageHeader";
import darkNewImg from "~/common/components/Images";
import { Case, If, OtherWise } from "~/common/components/If";
import lightNewImg from "~/assets/img/defaultImg/light-profile-large.png";
import darkInitImg from "~/assets/img/dark-init-img.png";
import lightInitImg from "~/assets/img/light-init-img.png";

export const ViewCard = ({ img, name, position, department, introduction }) => {

	const { t } = useTranslation();
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	return (
		<div className="c__card">
			<div className="member-img">
				<img
					src={img || (theme === "dark" ? darkNewImg : lightNewImg)}
					alt={t("pages.vcInfo.VcMember.View.photo")}
					onError={(e) => {
						e.target.src = theme === "dark" ? darkNewImg : lightNewImg;
					}}
				/>
			</div>
			<dl>
				<dt className="member-name">{name}</dt>
				<dd className="member-position">
					<span>{department}</span>
					<span>{position}</span>
				</dd>
				<dd className="member-email">
					{introduction &&
						introduction.split("\n").map((text) => {
							return (
								<span>
									{text}
									<br />
								</span>
							);
						})}
				</dd>
			</dl>
		</div>
	);
};

const View = ({ showEditPage, menu, type, data }) => {
	const { t } = useTranslation();

	const [
		{
			sidebar: { currentPath },
			theme: { theme },
		},
	] = useGlobalStore();

	const [showAuthAlert, AuthAlert] = useAlert();

	const buttonList = [
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={() => {
				if (currentPath.auth !== "edit") {
					showAuthAlert();
					return;
				}
				showEditPage();
			}}
		>
			{data.length === 0
				? t("pages.vcInfo.VcMember.View.add")
				: t("pages.vcInfo.VcMember.View.edit")}
		</button>,
	];

	const users = () => {
		return data.map(({ img, name, department, position, introduction }, index) => (
			<ViewCard key={index} {...{ img, name, department, position, introduction }} />
		));
	};
	return (
		<>
			{/* <PageHeader {...{ menu, type, buttonList }} /> */}
			<If condition={data.length}>
				<Case condition={0}>
					<div className="page-init">
						<p className="main">{t("pages.vcInfo.VcMember.View.wouldAddMemger")}</p>
						<p className="sub">{t("pages.vcInfo.VcMember.View.wouldAddMemgerMain")}</p>
						<img src={theme === "dark" ? darkInitImg : lightInitImg} alt="초기이미지" />
						{/*<img src={lightInitImg} alt="초기이미지" />*/}
					</div>
				</Case>
				<OtherWise>
					<div className="c__cardRow company-member-view">{users()}</div>
				</OtherWise>
			</If>
			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
		</>
	);
};

export default View;
